import type { WireItem } from "../api/types.js";
import { combinedTireField, formatDateTime } from "../domain/format.js";

/**
 * The swap flow: this customer's other stored, not-yet-picked-up items
 * (from `useSwapCandidates`) — selecting one marks it picked up in the same
 * request as the new intake (`swapOutItemId` on `POST /api/items`; see
 * `@skladiscenje/core`'s `planSwap`). Replaces the inline `listView` at the
 * bottom of `AddItemWindow.xaml` (create mode only — it's hidden entirely
 * in edit mode there, same here).
 */
export function SwapPicker({
  candidates,
  selectedId,
  onSelect,
}: {
  candidates: WireItem[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
}) {
  if (candidates.length === 0) return null;

  return (
    <fieldset className="swap-picker">
      <legend>V skladišču že ima (izberite, če stranka ob oddaji dviguje prejšnjo garnituro)</legend>
      <ul>
        <li>
          <label>
            <input type="radio" name="swap-candidate" checked={selectedId === null} onChange={() => onSelect(null)} />
            Brez dviga
          </label>
        </li>
        {candidates.map((item) => (
          <li key={item.id}>
            <label>
              <input
                type="radio"
                name="swap-candidate"
                checked={selectedId === item.id}
                onChange={() => onSelect(item.id)}
              />
              #{item.number ?? "?"} · {combinedTireField(item.tireSets, "dimension")} · {combinedTireField(item.tireSets, "maker")} ·{" "}
              {formatDateTime(item.receivedAt)}
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
